<template>
  <div>
    <div class="form-container">
      <div v-if="!isUserLoggedIn()" class="row">
        <div class="small-12 ">
          <div class="row">
            <div class="small-12 columns">
              <h4
                class=" link"
                style="text-align:center"
                :class="loginMode ? 'tab-on-toggled tab-on' : 'tab-on'"
                @click="loginMode = true"
              >
                Login
              </h4>
            </div>
          </div>
        </div>
        <div class="small-12">
          <form v-if="loginMode" @submit.prevent="login">
            <div class="flex">
              <label class="small-6 columns leading-loose" for="email"
                >Email</label
              >
              <input
                id="email"
                ref="email"
                v-model="id"
                class="my-2"
                type="email"
                autofocus
              />
            </div>
            <div class="flex">
              <label for="password" class="small-6 columns leading-loose"
                >Password</label
              >
              <input
                id="password"
                v-model="password"
                class="my-2"
                type="password"
              />
            </div>
            <div style="text-align:center;">
              <button class="button-blue px-4 py-2 w-1/2">
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
      <div v-if="isUserLoggedIn()" style="user-select:none;">
        <div class="continue-as-user-container">
          <div style="padding-bottom:10px;color:white;">Logged in as</div>
          <div>
            <span style="color:black;font-weight:700;">{{
              getUserName()
            }}</span>
            <span
              class=" link"
              style="padding-left:10px;color:white;font-size:0.8em;cursor:pointer;"
              @click="clickToContinue()"
              >Click Here To Continue</span
            >
          </div>
          <div
            class=" link"
            style="padding-top:40px;color:#06c;cursor:pointer;"
            @click="logOutUser"
          >
            Logout?
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "@/components/auth/library/auth"

export default {
  data() {
    return {
      id: undefined,
      password: undefined,
      error: true,
      loginMode: true,
      // /////////////
      // /////////////
      registrationID: undefined,
      registrationPassword: undefined,
      registrationConfirmPassword: undefined,
      fullName: undefined,
    }
  },
  mounted() {},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const userType = localStorage.role
      // redirecting only at the initial load if the user is logged in
      // but if he comes from another page not redirecting to handle
      // logout
      if (userType && vm.isUserLoggedIn() && from.name === null) {
        if (userType === "admin") {
          vm.$router.push("/courses")
        } else if (userType === "marketing") {
          vm.$router.push("/update-youtube-session")
        } else if (userType === "questionadmin") {
          vm.$router.push("/reading")
        }
      } else {
        vm.$router.push("/")
      }
    })
  },

  methods: {
    logOutUser() {
      localStorage.token = undefined
      localStorage.userName = undefined
      window.location.reload()
    },
    getUserName() {
      return localStorage.userName
    },
    clickToContinue() {
      if (localStorage.role === "marketing") {
        this.$router.push("/update-youtube-session")
      } else if (localStorage.role === "communityManager") {
        this.$router.push("/manage-students")
      } else {
        this.$router.push("/courses/")
      }
    },
    isUserLoggedIn() {
      if (localStorage.token === undefined) {
        return false
      }
      if (localStorage.token.length < 16) {
        return false
      }
      return true
    },
    login() {
      this.error = false
      auth.login(this.id, this.password).then(res => {
        if (!res.data.status) {
          this.$noty.error(res.data.error_message)
          this.$refs.email.focus()
          return
        }
        localStorage.token = res.data.token
        localStorage.userName = res.data.user_full_name

        if (this.id.startsWith("marketing@edyst.com")) {
          localStorage.role = "marketing"
          this.$router.go("/")
        } else if (this.id.startsWith("tech@edyst.com")) {
          localStorage.role = "admin"
          this.$router.push("/courses/")
        } else if (this.id.startsWith("questionadmin@edyst.com")) {
          localStorage.role = "questionadmin"
          this.$router.push("/reading")
        } else if (this.id.startsWith("community@edyst.com")) {
          localStorage.role = "communityManager"
          this.$router.push("/manage-students")
        } else {
          this.$router.push("/")
        }
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.continue-as-user-container {
  width: 96%;
  margin: auto;
  padding: 20px 0px;
  background-color: #4bd;
  font-weight: 700;
  text-align: center;
}
.tab-on {
  padding: 8px;
  border: 1px solid transparent;
  cursor: pointer;
}
.tab-on-toggled {
  border: 1px solid #4caf50;
  color: white;
  background-color: #4caf50;
}
.button-full {
  width: 94%;
  margin: auto;
  margin-top: 12px;
}
.social-login-container {
  margin-top: 40px;
  border-top: 1px solid black;
}
.form-container {
  width: 400px;
  margin: auto;
  margin-top: 60px;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: 1px 0px 4px rgba(0, 0, 0, 0.4);
}
.loginpage {
  width: 400px;
}
</style>
